<template>
  <div>
    <navigation />
    <div class="tasklist-container">
      <div class="tasklist">
        <!-- <button @click="toggleTaskList()" style="height: 38px;width: 88px;float: right;">独立审核</button> -->
        <div class="tasksearch" v-if="listTab === 'all'">
          <span>任务名：</span>
          <input v-model="taskName" class="input" type="text" placeholder="请输入任务名" @keyup.enter="getTaskList()" />
          <button
            @click="
              taskName = null;
              getTaskList();
            "
            v-show="clearButton"
            style="color: #5d89c0;background: #ffffff;border: 1px solid #5d89c0;margin-right: 18px;"
          >
            清除
          </button>
          <button @click="getTaskList()">搜索</button>
        </div>
        <div class="add-approve" v-if="listTab === 'approve'">
          <input v-model="newApprTask.taskName" class="input" type="text" placeholder="新审核任务名" />
          <input v-model="newApprTask.desc" class="input" type="text" placeholder="新审核任务描述（非必填）" />
          <button @click="addApprTask()">新建</button>
        </div>
        <ApproveTaskList v-if="listTab === 'approve'" :approve-task-list="approveTaskList" style="margin-top:26px;" />
        <tasklist
          v-if="listTab === 'all'"
          :task-list="taskList"
          :customer-list="customerList"
          @customerChange="
            customerId = $event;
            getTaskList();
          "
          @statusChange="
            taskStatus = $event;
            getTaskList();
          "
        />
        <pagination
          v-if="listTab === 'all'"
          :page-size="pageSize"
          :page-index="pageIndex"
          :item-total="itemTotal"
          @changeindex="changePageIndex"
          @changesize="changePageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import tasklist from '@/components/tasklist';
import ApproveTaskList from '@/components/ApproveTaskList';
import pagination from '@/components/pagination';
import navigation from '@/components/navigation';
import * as api from '@/api/api.js';

export default {
  name: 'task',
  data() {
    return {
      taskName: null,
      taskList: [],
      approveTaskList: [],
      customerList: [],
      customerId: null,
      pageSize: 20,
      pageIndex: 0,
      itemTotal: 0,
      clearButton: false,
      taskStatus: null,
      listTab: 'all', //all:所有任务 approve:独立审核任务
      newApprTask: { taskName: '', desc: '' },
    };
  },
  components: {
    tasklist,
    pagination,
    navigation,
    ApproveTaskList,
  },
  mounted: function() {
    this.getTaskList();
    this.getCustomer();
    // 将用户信息告知后台websocket
    this.$socket.emit('identity', {
      userId: this.$store.state.userId.toString(),
    });
  },
  methods: {
    toggleTaskList() {
      this.listTab = this.listTab === 'all' ? 'approve' : 'all';
    },
    getCustomer() {
      api
        .getUserList({ p: 0, s: 999, r: 2, stat: 0 })
        .then(res => {
          this.customerList = res.data.users;
        })
        .catch(() => {});
    },
    getTaskList(pi = 0) {
      this.clearButton = false;
      this.pageIndex = pi;
      let con = { page: this.pageIndex, pagesize: this.pageSize };
      if (this.taskName) {
        this.clearButton = true;
        con['taskname'] = this.taskName;
      }
      if (this.customerId) {
        con['creator'] = this.customerId;
      }
      if (this.taskStatus) {
        con['status'] = this.taskStatus;
      }
      api
        .getTaskList(con)
        .then(res => {
          if (res.data.taskCount) {
            this.taskList = res.data.tasks;
            this.itemTotal = res.data.taskCount;
            this.$message.success('获取任务列表成功');
          } else
            this.$notify({
              group: 'foo',
              text: '未找到对应任务',
              type: 'custom-red',
              duration: 1500,
            });
        })
        .catch(() => {});
    },
    changePageIndex: function(pi) {
      this.pageIndex = pi;
      this.getTaskList(pi);
    },
    changePageSize: function(ps) {
      this.pageSize = parseInt(ps);
      this.getTaskList();
    },
  },
};
</script>

<style type="text/css" scoped>
.tasksearch {
  height: 38px;
  margin: 0px 0px 36px;
  font-size: 14px;
}
.tasksearch span {
  font-size: 16px;
}
.tasksearch input {
  font-size: 14px;
  height: 100%;
  width: 304px;
  padding: 12px;
  margin: 0px 18px 0px 13px;
  box-sizing: border-box;
  vertical-align: top;
}
.tasksearch button {
  height: 100%;
  margin: 0px;
  width: 65px;
}
</style>
